import React from "react";
import { View, ScrollView, Text, SafeAreaView, Image, StyleSheet, ImageBackground, TouchableOpacity } from 'react-native'
import { useSelector } from "react-redux";
import { Header,HeaderRight,Label,Form} from "../../components/SharedComponents";
import styles from "../../shared/styles";
import { global } from "../../utils";
import { familyIc, ShildIc } from "../../shared/assets";
import localize from "../../shared/localize";

function TeamCreatedSuccess(props) {

    const userInfo = useSelector(({ auth }) => auth.userInfo)

    const _navigate = (pathname, state, search) => {
        if (!global.isNative) {
            return props.history.push({
                pathname: '/' + pathname,
                state,
                search
            });
        }
        return props.navigation.navigate(pathname, state)
    };


    return (
        <SafeAreaView style={styles.container}>

            {!global.isNative && (<Header title={localize.Done} right={(<HeaderRight onPress={() => _navigate('')} />)} />)}

            <ScrollView style={{ paddingHorizontal: 20 }}>
                <View style={{ alignItems: 'center' }}>
                    <View style={{ marginVertical: 30 }}>
                        <ImageBackground
                            source={familyIc}
                            style={pageStyles.img}
                            resizeMode="contain"
                        >
                            <Image
                                source={ShildIc}
                                style={pageStyles.imgSub}
                                resizeMode="contain"
                            />
                        </ImageBackground>
                    </View>
                    <Label.PrimaryTitle align="center">
                        {localize.Congratulations_you_have_successfully_created_team} <Text style={{ fontFamily: global.FONT_BOLD, textDecorationLine: "underline" }}>{userInfo && userInfo.family_name}</Text>. {localize.Would_you_like_to_add_more_members_to_the_team}
                    </Label.PrimaryTitle>
                </View>

                <View style={{ paddingVertical: 30 }}>
                    <Form.Button
                        title={localize.INVITE_A_CHILD}
                        size="small"
                        onPress={() => _navigate(global.isNative ? 'send_invite' : "invite/send-invite", { role: 0 })}
                    />
                    <View style={{ height: 8 }} />
                    <Form.Button
                        title={localize.INVITE_TRUSTED_ADULT}
                        size="small"
                        onPress={() => _navigate(global.isNative ? 'send_invite' : "invite/send-invite", { role: 1 })}
                    />
                    <View style={{ height: 8 }} />
                    <Form.Button
                        title={localize.INVITE_TEACHER}
                        size="small"
                        onPress={() => _navigate(global.isNative ? "send_invite" : "invite/send-invite", { role: 2 })}
                    />
                    <TouchableOpacity
                        onPress={() => {
                            if (global.isNative) return _navigate("dashboard");
                            let pathname = "Add-Bookmark"
                            if (global.APP_PLATFORM() === "ios" || global.APP_PLATFORM() === "and") pathname = "open-native-app"
                            if (window.wv || window.webkit) pathname = "dashboard";

                            return _navigate(pathname);
                        }}
                        style={{ alignSelf: "center", marginTop: 40 }}
                    >
                        <Label.LinkIndigo>
                            {localize.DO_IT_LATER}
                        </Label.LinkIndigo>
                    </TouchableOpacity>
                </View>
            </ScrollView>
        </SafeAreaView>
    )

}

TeamCreatedSuccess.navigationOptions = ({ navigation }) => {
    return {
        title: localize.Done,
        headerLeft: null,
        headerRight: (
            <HeaderRight onPress={() => navigation.navigate("dashboard")} />
        )
    };
};

export default TeamCreatedSuccess;

const pageStyles = StyleSheet.create({
    img: {
        width: 142,
        height: 142,
        borderRadius: 142,
        justifyContent: "flex-end",
        alignItems: "flex-end"
    },
    imgSub: {
        width: 50,
        height: 50,
        borderRadius: 25,
    }
})